import { Fragment, useState } from 'react';
import { ChevronRight, ChevronDown, ChevronUp } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function FoldersBreadcrumb({ items, onNavigate, rootLabel = 'Dossiers' }) {
    const [isExpanded, setIsExpanded] = useState(false);

    // Sur mobile, afficher seulement le dernier élément si fermé
    const hasMultipleItems = items.length > 0;
    const currentName = items.length === 0 ? rootLabel : items[items.length - 1]?.name || rootLabel;

    return (
        <nav className="min-w-0 w-full">
            {/* Desktop: 2 lignes - arborescence puis titre */}
            <div className="hidden sm:block">
                {/* Ligne 1 : Arborescence (cachée si racine) */}
                {items.length > 0 && (
                    <div className="flex flex-wrap items-center gap-1 pb-1">
                        <Button
                            variant="plain"
                            color="neutral"
                            size="xxs"
                            onClick={() => onNavigate(-1)}
                            className="text-xs font-medium text-muted-foreground hover:text-foreground px-1 py-0 h-auto shrink-0"
                        >
                            {rootLabel}
                        </Button>

                        {/* Afficher tous les parents (sauf le dernier qui est le titre) */}
                        {items.slice(0, -1).map((item, index) => (
                            <div className={'flex items-center'} key={item.id}>
                                <ChevronRight className="w-3 h-3 text-muted-foreground shrink-0" />
                                <Button
                                    variant="plain"
                                    color="neutral"
                                    size="xxs"
                                    onClick={() => onNavigate(index)}
                                    className="text-xs font-medium text-muted-foreground hover:text-foreground px-1 py-0 h-auto shrink-0 whitespace-nowrap"
                                    title={item.name}
                                >
                                    {item.name}
                                </Button>
                            </div>
                        ))}
                    </div>
                )}

                {/* Ligne 2 : Titre du dossier courant */}
                <h1 className="text-xl font-bold text-foreground">{currentName}</h1>
            </div>

            {/* Mobile: accordéon vertical avec liste au-dessus */}
            <div className="sm:hidden">
                {/* Contenu accordéon - AU-DESSUS du header */}
                {isExpanded && hasMultipleItems && (
                    <div className="mb-2 ml-2 border-l-2 border-border pl-3 space-y-1">
                        <Button
                            variant="plain"
                            color="neutral"
                            size="xxs"
                            onClick={() => {
                                onNavigate(-1);
                                setIsExpanded(false);
                            }}
                            className="text-xs font-medium text-muted-foreground hover:text-foreground px-1 py-0.5 h-auto"
                        >
                            {rootLabel}
                        </Button>

                        {items.slice(0, -1).map((item, index) => (
                            <div key={item.id} className="flex items-center">
                                <Button
                                    variant="plain"
                                    color="neutral"
                                    size="xxs"
                                    onClick={() => {
                                        onNavigate(index);
                                        setIsExpanded(false);
                                    }}
                                    className="text-xs font-medium text-muted-foreground hover:text-foreground px-1 py-0.5 h-auto truncate max-w-[250px]"
                                    title={item.name}
                                >
                                    {item.name}
                                </Button>
                            </div>
                        ))}
                    </div>
                )}

                {/* Header cliquable - dossier courant */}
                <Button
                    variant="plain"
                    color="neutral"
                    size="auto"
                    onClick={() => hasMultipleItems && setIsExpanded(!isExpanded)}
                    className="flex items-center gap-1 w-full h-auto p-0 text-left justify-start"
                >
                    {hasMultipleItems && (
                        <span className="text-muted-foreground">
                            {isExpanded ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
                        </span>
                    )}
                    <span className="text-lg font-bold text-foreground truncate">
                        {items.length === 0 ? rootLabel : items[items.length - 1]?.name || rootLabel}
                    </span>
                </Button>
            </div>
        </nav>
    );
}
